import { render, staticRenderFns } from "./AnnexRegistration.vue?vue&type=template&id=5cc77d60&scoped=true&"
import script from "./AnnexRegistration.js?vue&type=script&lang=js&"
export * from "./AnnexRegistration.js?vue&type=script&lang=js&"
import style0 from "./AnnexRegistration.vue?vue&type=style&index=0&id=5cc77d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc77d60",
  null
  
)

export default component.exports